import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { InTheLab } from './components/InTheLab';
import { Differentiators } from './components/Differentiators';
import { StudioStory } from './components/StudioStory';
import { LabFaq } from './components/LabFaq';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-cream" data-id="element-0" data-mp="2rkdxmv1kddoa">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-[2px] focus:bg-ink focus:px-5 focus:py-3 focus:text-sm focus:text-cream" data-id="element-1" data-mp="2rikmb2g0a59y">
        Skip to content
      </a>
      <SiteHeader data-id="element-2" data-mp="2wj8dpp85co4p" />
      <main id="main" data-id="element-3" data-mp="2wip54z4dzc3c">
        <Hero data-id="element-4" data-mp="2wi5qbra193tj" />
        <InTheLab data-id="element-5" data-mp="28u5zysgmvffh" />
        <Differentiators data-id="element-6" data-mp="28tme50nv46w6" />
        <StudioStory data-id="element-7" data-mp="28suw6sn6u7od" />
        <LabFaq data-id="element-8" data-mp="28sbend1g9lav" />
      </main>
      <SiteFooter data-id="element-9" data-mp="23vkzcrxgytqi" />
    </div>;
}